import { Button } from '@mantine/core'

// Solid primary CTA. The spec uses a flat action-color button (not a gradient).
// `filled` rides the scheme-aware primary: #4E9A80 (brand-action) in light,
// mint in dark. Label color comes from the theme's variantColorResolver
// (white in light, ink on the bright dark accent).
export const CtaButton = Button.withProps({
    variant: 'filled',
})
